import React from 'react';
import Button, { ButtonProps } from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import { Typography } from '@mui/material';

interface CustomButtonProps extends ButtonProps {
  selected?: boolean;
}

const CustomButton = styled(Button)<CustomButtonProps>(({ selected }) => ({
  borderColor: '#365F91',
  border: '1.2px solid transparent',
  background: selected
    ? '#FB5012'
    : `linear-gradient(black, black) padding-box,
    linear-gradient(180deg, #365f91 -4.29%, rgba(54, 95, 145, 0) 100%) border-box`,
  borderImageSlice: 1,
  borderRadius: '57px',
  '&:hover': {
    backgroundColor: selected
      ? '#FB5012'
      : `linear-gradient(black, black) padding-box,
    linear-gradient(180deg, #365f91 -4.29%, rgba(54, 95, 145, 0) 100%) border-box`,
  },
  marginBottom: '5px',
  justifyContent: 'flex-start',
  padding: '10px',
  minHeight: '56px',
  width: '100%',
  maxWidth: '261px',
  margin: 'auto',
  color: selected ? 'white' : '#585858',
  textTransform: 'none',
}));

interface MenuButtonProps extends CustomButtonProps {
  icon: React.ReactElement; // icon as a React component
  children: React.ReactNode;
}

const MenuButton: React.FC<MenuButtonProps> = ({
  icon,
  children,
  selected,
  ...props
}) => {
  return (
    <CustomButton
      startIcon={React.cloneElement(icon, {
        style: {
          width: '24px',
          paddingLeft: '5px',
          fill: 'none',
          stroke: selected ? 'currentColor' : '#585858', // Set fill color based on selected
        },
      })}
      selected={selected}
      {...props}
    >
      <Typography variant="body2">{children}</Typography>
    </CustomButton>
  );
};

export default MenuButton;
